import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import '../DataGrid.scss';

class DateFilter extends Component {

    render() {
        const { filter, filterDate, onChange, ...rest } = this.props;

        return (
            <div>
                <input
                    type="text"
                    onChange={event => onChange({ filterDate, content: event.target.value })}
                    placeholder={filterDate.toLocaleString()}
                    value={filter ? filter.value.content : ''}
                    className='pi-data-grid-filter-component pi-data-grid-filter-date'
                />
                {
                    filter && filter.value.content ?
                        <button className='pi-data-grid-filter-clear' onClick={() => onChange({ filterDate, content: '' })}>
                            <Icon name="close" color="grey" />
                        </button>
                        : null
                }
            </div>
        );

    }
}

DateFilter.propTypes = {
    filter: PropTypes.object,
    filterDate: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default DateFilter;